module.exports = __webpack_public_path__ + "img/buettner210.0b98c169.png";